import { type Registry as Services } from '@ember/service';
import { getOwner } from '@ember/application';
import { cached, tracked } from '@glimmer/tracking';
import { min } from 'date-fns/min';
import { max } from 'date-fns/max';
import type { OccasionRecord } from 'uplisting-frontend/services/calendar/-internals/record';
import type { LocationType } from 'uplisting-frontend/services/calendar/-internals/types';
import { computeDurationClass } from 'uplisting-frontend/services/calendar/-internals/meta';
import { nightsBetween } from 'uplisting-frontend/utils/date';

export class ConflictRecord {
  calendarManager!: Services['calendar/manager'];

  @tracked records!: OccasionRecord[];

  readonly isHeld: boolean;

  constructor(context, records: OccasionRecord[], isHeld = false) {
    this.records = records;
    this.isHeld = isHeld;

    this.calendarManager = getOwner(context)?.lookup(
      'service:calendar/manager',
    ) as Services['calendar/manager'];
  }

  @cached
  get location(): LocationType {
    const record = this.records[0] as OccasionRecord;

    return record.model.multiUnit || record.model.property;
  }

  @cached
  get startDate(): Date {
    return min(this.records.map((record) => record.meta.startDate));
  }

  @cached
  get endDate(): Date {
    return max(this.records.map((record) => record.meta.endDate));
  }

  @cached
  get duration(): number {
    return nightsBetween(this.startDate, this.endDate);
  }

  // we need that class only for normal viewport
  // because monthly viewport has its own duration classes
  @cached
  get durationClass(): string {
    return computeDurationClass(this);
  }
}
